(() => {
    let tag_url = document.querySelector(".all_article_details").getAttribute('data-url');
    let article_limit = 3;
    if(!tag_url) return;

    fetch(`${tag_url}`)
        .then((response) => response.text())
        .then((responseText) => {
            let html = new DOMParser().parseFromString(responseText, 'text/html');
            let articles = html.querySelectorAll('.article_details_box');
            let article_box = document.querySelector(".all_article_details");
            
            let article_html='';
            if(articles){
                // console.log(articles);
                [...articles].slice(0,article_limit).forEach(function(article) {
                    article_html += article.outerHTML;
                });
                article_box.innerHTML = article_html;
            }
        })
        .catch((e) => {
            console.error(e);
        });
})();
